module.exports = __webpack_public_path__ + "static/img/solutionConceptPic5.b862448.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionConceptPic5.jpg
// module id = ve6t
// module chunks = 0